import { jsx as _jsx } from "react/jsx-runtime";
import { Source, Layer } from "react-map-gl/mapbox";
import { useTokens } from "@gemini/core";
import { GEO_LAYER_PATH } from "@/constants";
import { useBrandUrl } from "@/hooks";
import { MIN_ZOOM, MAX_ZOOM, DEFAULT_LAYER_TYPE } from "../../../constants";
import { useMapContext } from "../../../contexts/MapContext";
export const POFITramSourceAndLayer = () => {
    const { layers } = useMapContext();
    const tileApiUrl = useBrandUrl({ endpoint: GEO_LAYER_PATH });
    const { "color.border.default.default": defaultGrey } = useTokens();
    return (_jsx(Source, { type: "vector", id: "pofi-tram-source", minzoom: MIN_ZOOM, maxzoom: MAX_ZOOM, tiles: [`${tileApiUrl}/${DEFAULT_LAYER_TYPE}/TRAM.LINE/{z}/{x}/{y}.pbf`], children: _jsx(Layer, { type: "line", id: "pofi-tram-layer", source: "pofi-tram-source", "source-layer": "POFI", paint: {
                "line-color": ["coalesce", ["get", "color"], defaultGrey],
                "line-width": 5,
            }, layout: {
                visibility: layers.pofi_tram_line ? "visible" : "none",
            } }) }));
};
